import styled, { css } from 'styled-components';

import { StyledFlex } from '@dreryk/react-components';

export const StyledHistoricalVisitPrescription = styled(StyledFlex)<{ annulled: boolean; firstElement: boolean }>`
   margin-top: ${({ firstElement }) => (firstElement ? '5px' : '10px')};

   ${({ annulled, theme }) =>
      annulled &&
      css`
         color: ${theme.disabled};
      `}
`;

StyledHistoricalVisitPrescription.displayName = 'StyledHistoricalVisitPrescription';
